{
    "Accessibility menu": "Menú d'accessibilitat",
    "Close": "Tancar",
    "Content adjustments": "Ajustos de contingut",
    "Navigation adjustments": "Ajustos de navegació",
    "Text Align": "Alineació del text",
    "Align Left": "Alinear a l'esquerra",
    "Align Center": "Centrar",
    "Align Right": "Alinear a la dreta",
    "Adjust Font Size": "Ajustar la mida de la font",
    "Highlight Title": "Destacar títol",
    "Highlight Links": "Destacar enllaços",
    "Readable Font": "Font llegible",
    "Colour adjustments": "Ajustos de color",
    "Dark Contrast": "Contrast fosc",
    "Light Contrast": "Contrast clar",
    "High Contrast": "Alt contrast",
    "High Saturation": "Alta saturació",
    "Low Saturation": "Baixa saturació",
    "Monochrome": "Monocrom",
    "Tools": "Eines",
    "Reading Guide": "Guia de lectura",
    "Big Cursor": "Cursor gran",
    "Increase Font Size": "Augmentar mida de la font",
    "Decrease Font Size": "Reduir mida de la font",
    "Letter Spacing": "Espaiat entre lletres",
    "Line Height": "Alçada de línia",
    "Font Weight": "Gruix de la font",
    "Dyslexia Font": "Font per a dislèxia",
    "Language": "Idioma",
    "Accessibility widget": "Obrir menú d'accessibilitat",
    "Accessibility Profiles": "Perfils d'accessibilitat",
    "Cognitive Disability": "Discapacitat cognitiva",
    "Seizure Safe": "Segur per a epilèpsia",
    "Accessibility statement": "Declaració d'accessibilitat",
    "ADHD": "TDAH",
    "Low Vision": "Baixa visió",
    "Pause Animations": "Aturar animacions",
    "Animation paused": "Animació en pausa",
    "Reset all settings": "Restablir configuració",
    "Shortcut:": "Drecera:",
    "Epilepsy Safe Mode": "Mode segur per a l'epilèpsia",
    "Mute sounds": "Silenciar els sons",
    "Page read": "Lectura de la pàgina",
    "Page read controls": "Controls de lectura",
    "Pause": "Pausa",
    "Resume": "Reprendre",
    "Stop": "Aturar",
    "Settings": "Configuració",
    "Speed": "Velocitat",
    "Voice": "Veu",
    "Close accessibility menu": "Tancar el menú d'accessibilitat",
    "Back to accessibility menu": "Tornar al menú d'accessibilitat",
    "Search languages": "Cercar idiomes",
    "Selected language": "Idioma seleccionat",
    "View accessibility statement (opens in new window)": "Veure la declaració d'accessibilitat (s'obre en una finestra nova)",
    "Visit CookieYes website (opens in new window)": "Visitar el lloc web de CookieYes (s'obre en una finestra nova)",
    "Reset all accessibility settings to default": "Restablir tota la configuració d'accessibilitat"
}
